<template>
  <v-container fluid fill-height ma-0 pa-0 @click.stop="" class="white">
    <v-layout column fill-height justify-start style="position: inherit; overflow: hidden;">
      <nms-map
        v-if="getMapMode" 
      />
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import nmsMap from '@/nms/components/map/main.vue'

export default Vue.extend({
  name: 'TOPOLOGY',

  components: {
    nmsMap,
  },

  data(): {
    mapMode: boolean
  } {
    return {
      mapMode: true,
    }
  },

  computed: {
    getMapMode(): boolean {
      return this.mapMode
    },
  },

  created(): void {
    // Метод предназначен для переопределения при необходимости
  },

  mounted(): void {
    // Метод предназначен для переопределения при необходимости
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },
  },
})
</script>

<style>

</style>
